import type { AxiosResponse } from "axios";
import type { ThunkResult } from "src/app/reducers/IMainAppState";
import { LIST_API_PATH } from "src/confs/APIConfig";
import type { DispatchTag } from "src/dispatches/objects/DispatchTag";
import type Criteria from "src/dispatches/objects/selectioncriteria/criteria/Criteria";
import List, { type ListStatus } from "src/lists/objects/List";
import { APIGet, APIPost, APIPostAxios } from "src/shared/actions/FetchActions";

export function GetLists(status?: ListStatus): ThunkResult<Promise<List[]>> {
  return async (dispatch) => {
    const url: URL = new URL(LIST_API_PATH);
    if (status) {
      url.searchParams.set("status", status);
    }

    const fetchResult: Response = await dispatch(APIGet(url.toString()));
    const json = await fetchResult.json();
    return json.map((listJSON: string) => {
      return new List(listJSON);
    });
  };
}

export function EstimateReachForList(
  listUuid: string,
  dispatchSelectionCriteria: Criteria,
): ThunkResult<Promise<number>> {
  return async (dispatch) => {
    const url: URL = new URL(`${LIST_API_PATH}/action/_estimate`);
    url.searchParams.set("listUuid", listUuid);
    url.searchParams.set(
      "dispatchSelectionCriteria",
      JSON.stringify(dispatchSelectionCriteria),
    );

    const fetchResult: Response = await dispatch(APIPost(url.toString()));
    const result: { estimatedCount: number } = await fetchResult.json();
    return result.estimatedCount;
  };
}

export function GetDispatchTagsForList(): ThunkResult<Promise<DispatchTag[]>> {
  return async (dispatch) => {
    const fetchResult: Response = await dispatch(
      APIGet(`${LIST_API_PATH}/at-tags`),
    );
    return await fetchResult.json();
  };
}

export function CreateList(
  list: List,
  onUploadProgress?: (progressEvent: ProgressEvent) => void,
): ThunkResult<Promise<string>> {
  return async (dispatch) => {
    const response: AxiosResponse<{ listUuid: string }> = await dispatch(
      APIPostAxios<{ listUuid: string }>(
        `${LIST_API_PATH}/action/_upload`,
        list.toFormData(),
        {
          onUploadProgress,
        },
      ),
    );
    return response.data.listUuid;
  };
}
